module.exports = __webpack_public_path__ + "c9a114b1339fce80ba19ff193b01ee75.png";